import { normalizeMathText } from "./chatMath";
import { parseMathText } from "./parseMathText";
import {
  extractDifferentialVariable,
  listSingleLetterVariables,
  replaceLatexVariable,
} from "./variableReplace";

const FILLER_PREFIXES = [
  /^i\s*(guess|think|feel|believe|suppose|assume)\b[:,-]?\s*/i,
  /^(maybe|perhaps|probably)\b[:,-]?\s*/i,
  /^(not\s*sure|unsure|idk|i\s*don'?t\s*know)\b[:,-]?\s*/i,
];

export const cleanFlashcardText = (value) => {
  let text = String(value || "").trim();
  if (!text) return "";
  let updated = text;
  FILLER_PREFIXES.forEach((pattern) => {
    if (pattern.test(updated)) {
      updated = updated.replace(pattern, "");
    }
  });
  return updated.replace(/\s+/g, " ").trim();
};

const normalizeLatexVariablesByDifferential = (latex) => {
  const diffVar = extractDifferentialVariable(latex);
  if (!diffVar) return latex;
  const vars = Array.from(listSingleLetterVariables(latex));
  const nonDiff = vars.filter((variable) => variable !== diffVar);
  if (nonDiff.length !== 1) return latex;
  const candidate = nonDiff[0];
  if (!candidate || candidate === diffVar) return latex;
  const adjacencyPattern = new RegExp(
    `${candidate}\\s*${diffVar}|${diffVar}\\s*${candidate}`
  );
  if (adjacencyPattern.test(latex)) return latex;
  return replaceLatexVariable(latex, candidate, diffVar);
};

export const getFlashcardParts = (text) => {
  const cleaned = cleanFlashcardText(text);
  const normalized = normalizeMathText(cleaned);
  const parts = parseMathText(normalized);
  return parts.map((part) => {
    if (part.type !== "latex") return part;
    return {
      ...part,
      value: normalizeLatexVariablesByDifferential(part.value),
    };
  });
};
